<template>
	<div id="app" :class="{ scrolled: scrolled }">
		<c-header :pdfLink="pdfLinks.full"/>
		<transition name="fade" mode="out-in">
			<router-view :pdfLink="pdfLinks.pages"/>
		</transition>
		<c-footer :pdfLink="pdfLinks.full"/>
	</div>
</template>
<script>
	import '@/styles/main.scss'
	// components
	import cHeader from '@/components/Header.vue'
	import cFooter from '@/components/Footer.vue'
	// pdfs (en)
	import pdfFullEn 			from '@/assets/pdf/en/full.pdf'
	import pdfCeoEn 			from '@/assets/pdf/en/ceo.pdf'
	import pdfFokusEn			from '@/assets/pdf/en/fokus.pdf'
	import pdfHallbartEn 		from '@/assets/pdf/en/hallbart.pdf'
	import pdfInvestmentEn 		from '@/assets/pdf/en/investments.pdf'
	import pdfNyproduktionEn 	from '@/assets/pdf/en/nyproduktion.pdf'
	import pdfNytankandetEn 	from '@/assets/pdf/en/nytankande.pdf'
	import pdfSamhalletEn 		from '@/assets/pdf/en/samhallet.pdf'
	import pdfAnsvarsfulltEn 	from '@/assets/pdf/en/ansvarsfullt.pdf'
	import pdfHallbarhetEn		from '@/assets/pdf/en/hallbarhet.pdf'
	import pdfSvanenmarktaEn 	from '@/assets/pdf/en/svanenmarkta.pdf'
	import pdfKompetensEn 		from '@/assets/pdf/en/kompetens.pdf'
	import pdfMiljoarbeteEn 	from '@/assets/pdf/en/miljoarbete.pdf'
	import pdfNummerEn			from '@/assets/pdf/en/nummer.pdf'
	// pdfs (sv)
	import pdfFullSv 			from '@/assets/pdf/sv/full.pdf'
	import pdfCeoSv 			from '@/assets/pdf/sv/ceo.pdf'
	import pdfFokusSv 			from '@/assets/pdf/sv/fokus.pdf'
	import pdfHallbartSv 		from '@/assets/pdf/sv/hallbart.pdf'
	import pdfInvestmentSv 		from '@/assets/pdf/sv/Investment.pdf'
	import pdfNyproduktionSv 	from '@/assets/pdf/sv/nyproduktion.pdf'
	import pdfNytankandetSv 	from '@/assets/pdf/sv/nytankande.pdf'
	import pdfSamhalletSv 		from '@/assets/pdf/sv/samhallet.pdf'
	import pdfAnsvarsfulltSv 	from '@/assets/pdf/sv/ansvarsfullt.pdf'
	import pdfHallbarhetSv 		from '@/assets/pdf/sv/hallbarhet.pdf'
	import pdfSvanenmarktaSv 	from '@/assets/pdf/sv/svanenmarkta.pdf'
	import pdfKompetensSv 		from '@/assets/pdf/sv/kompetens.pdf'
	import pdfMiljoarbeteSv 	from '@/assets/pdf/sv/miljoarbete.pdf'
	import pdfNummerSv 			from '@/assets/pdf/sv/nummer.pdf'
	// export
	export default {
		name: 'app',
		metaInfo: {
			title: 'JM 2020',
			titleTemplate: null
		},
		components: {
			cHeader,
			cFooter
		},
		data() {
			return {
				headerHeight: 0,
				scrolled: false,
				page: {
					client: 'JM',
					title: 'JM 2020'
				},
				pdfLinks: {
					full: {
						org: {
							en: pdfFullEn,
							sv: pdfFullSv
						},
						fallback: {
							en: pdfFullEn,
							sv: pdfFullSv
						},
						page: {
							en: 1,
							sv: 1
						}
					},
					pages: {
						ceo: {
							org: {
								en: pdfFullEn,
								sv: pdfFullSv
							},
							fallback: {
								en: pdfCeoEn,
								sv: pdfCeoSv
							},
							page: {
								en: 6,
								sv: 6
							}
						},
						hallbart: {
							samhallet: {
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfHallbartEn,
									sv: pdfHallbartSv
								},
								page: {
									en: 43,
									sv: 43
								}
							},
							verksamhet: {
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfMiljoarbeteEn,
									sv: pdfMiljoarbeteSv
								},
								page: {
									en: 46,
									sv: 46
								}
							},
							svanmarkta: {
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfSvanenmarktaEn,
									sv: pdfSvanenmarktaSv
								},
								page: {
									en: 50,
									sv: 50
								}
							},
							kompetens: {
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfKompetensEn,
									sv: pdfKompetensSv
								},
								page: {
									en: 52,
									sv: 52
								}
							},
							ansvarsfullt: {
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfAnsvarsfulltEn,
									sv: pdfAnsvarsfulltSv
								},
								page: {
									en: 60,
									sv: 60
								}
							},
							hallbart: {
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfHallbarhetEn,
									sv: pdfHallbarhetSv
								},
								page: {
									en: 42,
									sv: 42
								}
							},
						},
						investering: {

								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfInvestmentEn,
									sv: pdfInvestmentSv
								},
								page: {
									en: 9,
									sv: 9
								}

						},
						kunden: {
							utveckling:{
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfNytankandetEn,
									sv: pdfNytankandetSv
								},
								page: {
									en: 18,
									sv: 18
								}
							},
							nyproduktion:{
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfNyproduktionEn,
									sv: pdfNyproduktionSv
								},
								page: {
									en: 19,
									sv: 19
								}
							},
							focus:{
								org: {
									en: pdfFullEn,
									sv: pdfFullSv
								},
								fallback: {
									en: pdfFokusEn,
									sv: pdfFokusSv
								},
								page: {
									en: 21,
									sv: 21
								}
							},
						},
						number: {

							org: {
								en: pdfFullEn,
								sv: pdfFullSv
							},
							fallback: {
								en: pdfNummerEn,
								sv: pdfNummerSv
							},
							page: {
								en: 5,
								sv: 5
							}

						},
						samhallet: {
							org: {
								en: pdfFullEn,
								sv: pdfFullSv
							},
							fallback: {
								en: pdfSamhalletEn,
								sv: pdfSamhalletSv
							},
							page: {
								en: 28,
								sv: 28
							}
						}
					}
				}
			}
		},
		methods: {
			handleResize(e) {
				setTimeout(function() {
					const container = document.getElementById('nav')
					this.headerHeight = container.offsetHeight
				}.bind(this), 500)
			},
			handleScroll(e) {
				let scrollTop = document.body.scrollTop
				if (scrollTop == 0) {
					if (window.pageYOffset)
						scrollTop = window.pageYOffset
					else
						scrollTop = (document.body.parentElement) ? document.body.parentElement.scrollTop : 0
				}
				if(scrollTop > (this.headerHeight / 2)) {
					this.scrolled = true
				} else {
					this.scrolled = false
				}
			}
		},
		created() {
			window.addEventListener('resize', this.handleResize)
			window.addEventListener('scroll', this.handleScroll)
		},
		mounted() {
			this.$nextTick(function() {
				setTimeout(function() {
					const container = document.getElementById('nav')
					this.headerHeight = container.offsetHeight
				}.bind(this), 500)
			}.bind(this))
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize)
			window.removeEventListener('scroll', this.handleScroll)
		}
	}
</script>
<style>
	.fade-enter-active,
	.fade-leave-active {
		transition-duration: 0.3s;
		transition-property: opacity;
		transition-timing-function: ease;
	}
	.fade-enter,
	.fade-leave-active {
		opacity: 0
	}
</style>
